import React,{useEffect, useState} from 'react';

import project1 from "../../Images/blog1.png";
import project2 from "../../Images/blog2.png";
import project3 from "../../Images/blog3.png";
import project4 from "../../Images/blog4.png";

export default function Work(){
    const[offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 1180px)").addListener(handler);

        return () =>window.removeEventListener("scroll", handleScroll);
    },[])

    return(
        <div className="Work Product">
            <div className="work-intro" data-aos="fade-right">
                <h2 className="work-Title">Latest articles on design, development and experience.</h2>
                <p className="work-slogan">Level up your development skills and learn about interactive projects, ideas and a lot more.</p>
            </div>
            {media.matches && (
                <div>
            <div className="portfolio">
                <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-neumorphism-ui-ux-design-1ffaf46226f0">
                <div className="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project1} className="blogimg" />
                    </div>
                    <div className="project-des blog-des" >
                        <div>
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Neumorphism UI/UX Design.</h3>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">8K+</div>
                    </div>
                </div>
                </a>
                <a href="https://uxplanet.org/my-portfolio-website-helps-me-to-get-a-full-stack-internship-32c2f70d8a8f">
                <div Class="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project2} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">My Portfolio Website Helps Me To Get A Full Stack Internship.</h3>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
                </a>
            </div>
            <div className="portfolio sec-port">
                <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-glassmorphism-ui-ux-design-848599c74094">
                <div className="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project3} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Glassmorphism UI/UX Design.</h3>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
                </a>
                <a href="https://uxplanet.org/5-best-landing-pages-that-anyone-can-create-254ce1f9c91c">
                <div Class="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project4} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">5 Best Landing Pages that Anyone Can Create.</h3>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">2K+</div>
                    </div>
                </div>
                </a>
            </div>
            <div className="portfolio sec-port">
                <a href="https://uxplanet.org/a-complete-sde-full-stack-developer-portfolio-projects-8c29e892a408">
                <div className="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img open-img">
                        <img src="https://miro.medium.com/max/700/1*pv-5G5HqyWiBvPy6fTZSpA.jpeg" className="blogimg" />
                    </div>
                    <div className="project-des blog-des" >
                        <div>
                            <h3 className="des-head blog-head">A Complete SDE/ Full Stack Developer Portfolio Projects.</h3>
                            <p className="blog-para">4 min Read</p>
                        </div>
                        <div className="blog-views">1K+</div>
                    </div>
                </div>
                </a>
                <a href="https://medium.com/dev-genius/my-full-stack-web-development-internship-experience-39bd77ebf5db">
                <div Class="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img open-img">
                        <img src="https://miro.medium.com/max/700/1*Su_uqZVJh8_DufNEo8wVTA.jpeg" className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">My Full Stack Web Development Internship Experience.</h3>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">2K+</div>
                    </div>
                </div>
                </a>
            </div>
            <div className="portfolio sec-port">
                <a href="https://medium.com/dev-genius/become-a-successful-full-stack-developer-from-scratch-b2085b01b24d">
                <div className="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img open-img">
                        <img src="https://miro.medium.com/max/700/1*NgvAwgaR7su20PtMXOiVRw.png" className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">Become a Successful Full Stack Developer from Scratch.</h3>
                            <p className="blog-para">6 min Read</p>
                        </div>
                        <div className="blog-views">3K+</div>
                    </div>
                </div>
                </a>
                <a href="https://medium.com/dev-genius/amazing-techniques-to-study-web-development-better-b75a7374bea2">
                <div Class="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img open-img">
                        <img src="https://miro.medium.com/max/2400/1*mVHJ0PjffJfB821mMB-pJA.jpeg" className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">Amazing Techniques To Study Web Development Better.</h3>
                            <p className="blog-para">6 min Read</p>
                        </div>
                        <div className="blog-views">1K+</div>
                    </div>
                </div>
                </a>
            </div>
            <div className="social-footer" data-aos="fade-up">
                <a href="https://medium.com/@vikalpkaushik99"><button className="social-btn">Upto Date Blogs 📝</button></a>
            </div>
            </div>
            )}
            {!media.matches && (
                <div>
            <div className="portfolio">
               
                <div className="project-div blog-div">
                    <div className="project-img blog-img">
                        <img src={project1} className="blogimg" />
                    </div>
                    <div className="project-des blog-des" >
                        <div>
                            <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-neumorphism-ui-ux-design-1ffaf46226f0">
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Neumorphism UI/UX Design.</h3>
                            </a>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">8K+</div>
                    </div>
                    
                </div>
                <div Class="project-div blog-div">
                    <div className="project-img blog-img">
                        <img src={project2} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                        <a href="https://uxplanet.org/my-portfolio-website-helps-me-to-get-a-full-stack-internship-32c2f70d8a8f">
                            <h3 className="des-head blog-head">My Portfolio Website Helps Me To Get A Full Stack Internship.</h3>
                            </a>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
            </div>
            <div className="portfolio sec-port">
                
                <div className="project-div blog-div">
                    <div className="project-img blog-img">
                        <img src={project3} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                        <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-glassmorphism-ui-ux-design-848599c74094">
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Glassmorphism UI/UX Design.</h3>
                            </a>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
            
                    <div Class="project-div blog-div">
                        <div className="project-img blog-img">
                            <img src={project4} className="blogimg" />
                        </div>
                        <div className="project-des blog-des">
                            <div>
                            <a href="https://uxplanet.org/5-best-landing-pages-that-anyone-can-create-254ce1f9c91c">
                                <h3 className="des-head blog-head">5 Best Landing Pages that Anyone Can Create.</h3>
                                </a>
                                <p className="blog-para">3 min Read</p>
                            </div>
                            <div className="blog-views">2K+</div>
                        </div>
                    </div>
            </div>
            <div className="portfolio sec-port">
               
                <div className="project-div blog-div">
                    <div className="project-img blog-img open-img">
                        <img src="https://miro.medium.com/max/700/1*pv-5G5HqyWiBvPy6fTZSpA.jpeg" className="blogimg" />
                    </div>
                    <div className="project-des blog-des" >
                        <div>
                            <a href="https://uxplanet.org/a-complete-sde-full-stack-developer-portfolio-projects-8c29e892a408">
                            <h3 className="des-head blog-head">A Complete SDE/ Full Stack Developer Portfolio Projects.</h3>
                            </a>
                            <p className="blog-para">4 min Read</p>
                        </div>
                        <div className="blog-views">1K+</div>
                    </div>
                    
                </div>
                <div Class="project-div blog-div">
                    <div className="project-img blog-img open-img">
                        <img src="https://miro.medium.com/max/700/1*Su_uqZVJh8_DufNEo8wVTA.jpeg" className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                        <a href="https://medium.com/dev-genius/my-full-stack-web-development-internship-experience-39bd77ebf5db">
                            <h3 className="des-head blog-head">My Full Stack Web Development Internship Experience.</h3>
                            </a>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">2K+</div>
                    </div>
                </div>
            </div>
            <div className="portfolio sec-port">
                
                <div className="project-div blog-div">
                    <div className="project-img blog-img open-img">
                        <img src="https://miro.medium.com/max/700/1*NgvAwgaR7su20PtMXOiVRw.png" className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                        <a href="https://medium.com/dev-genius/become-a-successful-full-stack-developer-from-scratch-b2085b01b24d">
                            <h3 className="des-head blog-head">Become a Successful Full Stack Developer from Scratch.</h3>
                            </a>
                            <p className="blog-para">6 min Read</p>
                        </div>
                        <div className="blog-views">3K+</div>
                    </div>
                </div>
            
                    <div Class="project-div blog-div">
                        <div className="project-img blog-img open-img">
                            <img src="https://miro.medium.com/max/700/1*mVHJ0PjffJfB821mMB-pJA.jpeg" className="blogimg" />
                        </div>
                        <div className="project-des blog-des">
                            <div>
                            <a href="https://medium.com/dev-genius/amazing-techniques-to-study-web-development-better-b75a7374bea2">
                                <h3 className="des-head blog-head">Amazing Techniques To Study Web Development Better.</h3>
                                </a>
                                <p className="blog-para">6 min Read</p>
                            </div>
                            <div className="blog-views">1K+</div>
                        </div>
                    </div>
            </div>
            
            <div className="social-footer">
                <a href="https://medium.com/@vikalpkaushik99"><button className="social-btn">Upto Date Blogs 📝</button></a>
            </div>
            </div>
            )}
        </div>
    )
}